import {useMemo, useRef} from 'react'
import {Pagination} from 'react-bootstrap'
import {useTable, useSortBy, useGlobalFilter, usePagination} from 'react-table'
import TableTemplate from './TableTemplate'
import {GlobalFilter} from './GlobalFilter'

const CRUDTable = (props) => {
  const {
    fieldToLabelMap = {},
    Form = () => <div></div>,
    cellModifier = {},
    data = [],
    headerExtras = <></>,
    noDataMessage = 'No Records Found',
    isSearchable = true,
    nonSortableColumns = [],
  } = props

  const columnData = useRef(
    Object.keys(fieldToLabelMap).map((field, i) => {
      const column = {
        Header: fieldToLabelMap[field] ?? 'Missing Column Head',
        accessor: field,
      }

      if (cellModifier[field]) {
        column.Cell = (value) => cellModifier[field](value) ?? ''
      }

      return column
    })
  )

  const columns = useMemo(() => columnData.current, [])

  const memoizeData = useMemo(() => data, [data])

  const tableInstance = useTable(
    {
      columns,
      data: memoizeData,
      autoResetGlobalFilter: false,
      autoResetSortBy: false,
      autoResetPage: false,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    pageCount,
    gotoPage,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,   // ✅ ADD THIS
  } = tableInstance

  const {globalFilter, pageIndex} = state
  const pageSizeOptions = [10, 25, 50, 100, 200, 300,500,700,1000]

  let formType = {}

  if (typeof Form === typeof function () {}) {
    formType.add = Form
    formType.update = Form
  } else if (Object.keys(Form).length === 1) {
    formType.add = Form.add || Form.update
    formType.update = Form.add || Form.update
  } else {
    formType = {...Form}
  }

  const totalEntries = data.length

  // Get the current page size
  const pageSize = state.pageSize

  // Calculate the range of entries being shown
  const startRow = state.pageIndex * pageSize + 1
  const endRow = Math.min(startRow + page.length - 1, totalEntries)

  return (
    <div className="bg-body rounded-3 p-10">
      <div className="d-flex align-items-center">
        {isSearchable && (
          <span>
            <GlobalFilter
              filter={globalFilter}
              setFilter={setGlobalFilter}
              placeholder={'Search all columns'}
            />
          </span>
        )}
        {headerExtras}
      </div>

      <div className="pt-4">
        <TableTemplate
          getTableProps={getTableProps}
          getTableBodyProps={getTableBodyProps}
          headerGroups={headerGroups}
          page={page}
          prepareRow={prepareRow}
          nonSortableColumns={nonSortableColumns}
        />
        {page?.length === 0 ? (
          <div className="text-center h1 py-8 m-0 text-muted">{noDataMessage}</div>
        ) : (
          <div className="d-flex justify-content-between align-align-items-center pt-5 px-6">
            <span className="align-self-center text-muted fs-6">
              Showing {startRow} to {endRow} of {totalEntries} entries
            </span>
            <select
        className="form-select form-select-sm"
        style={{width: '90px'}}
        value={state.pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value))
        }}
      >
        {pageSizeOptions.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
            <Pagination size="sm">
              <Pagination.First disabled={!canPreviousPage} onClick={() => gotoPage(0)} />

              <Pagination.Prev disabled={!canPreviousPage} onClick={() => previousPage()} />

              <Pagination.Item>
                {pageIndex + 1} of {pageOptions.length}
              </Pagination.Item>

              <Pagination.Next disabled={!canNextPage} onClick={() => nextPage()} />

              <Pagination.Last disabled={!canNextPage} onClick={() => gotoPage(pageCount - 1)} />
            </Pagination>
          </div>
        )}
      </div>
    </div>
  )
}

export default CRUDTable
